import * as apis from '@/apis/contract';
import * as actions from '@/actions';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import { getServiceNumberArray } from '@/helpers/catalogue';
import {
  CONTRACT_GET_ELIGIBILITY_REQUEST,
  CONTRACT_GET_EXISTINGVAS_REQUEST,
  CONTRACT_GET_PRICE_PLANS_REQUEST,
  CONTRACT_GET_SERVICE_NUMBERS_REQUEST,
  CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_REQUEST,
  CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_REQUEST,
  ADDONS_EXISTINGVAS_REQUEST,
  FILTER_BY_EXPIRY_REQUEST,
  CONTACT_EXPIRY_REQUEST,
  FILTER_BY_SIM_REQUEST,
  ACTIVATE_SIM_REQUEST,
  CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_REQUEST,
  CEASE_ADDONS_GET_SERVICE_NUMBERS_REQUEST,
  CEASE_ADDONS_DETAILS_REQUEST,
  SUSPEND_LINE_GET_SERVICE_NUMBERS_REQUEST,
  REFIT_LINE_SERVICE_NUMBERS_REQUEST,
  SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_REQUEST
} from '@/actions/contract/actionTypes';

import {
  ContractServiceNumbersRequest,
  ContractServiceNumbersForTerminateNumberRequest,
  ContractServiceNumbersForChangePlanRequest,
  ContractServiceNumbersWithNTRequest
} from '@/actions/contract/models/types';
import navigate from '@/helpers/navigation';

export const getAuth = (state) => state.auth;
export const getOrder = (state) => state.order;

function* getContractPricePlans() {
  try {
    const auth = yield select(getAuth);
    const brn = auth.currentAccount.brn;
    const msaHeaderId = auth.currentAccount.msaheaderId;
    const result = yield call(apis.getContractPricePlans, { brn, msaHeaderId });

    yield put(actions.getContractPricePlans.success(result.data));
  } catch (error) {
    yield put(actions.getContractPricePlans.failure(error));
  }
}

function* getRecontractEligibilityValues() {
  try {
    const result = yield call(apis.getRecontractEligibilityValues);
    yield put(actions.getRecontractEligibilityValues.success(result.data));
  } catch (error) {
    yield put(actions.getRecontractEligibilityValues.failure(error));
  }
}

function* getAddOnsExistingVasValues() {
  try {
    const auth = yield select(getAuth);
    const brn = auth.currentAccount.brn;
    const result = yield call(apis.getAddOnsExistingVasValues, { brn });
    yield put(actions.getAddOnsExistingVasValues.success(result.data));
  } catch (error) {
    yield put(actions.getAddOnsExistingVasValues.failure(error));
  }
}

function* getContactExpiryValues() {
  try {
    const result = yield call(apis.getContactExpiryValues);
    yield put(actions.getContactExpiry.success(result.data));
  } catch (error) {
    yield put(actions.getContactExpiry.failure(error));
  }
}

function* getContractServiceNumbers({ reqData }: ContractServiceNumbersRequest) {
  try {
    const auth = yield select(getAuth);
    yield select(getOrder);
    const brn = auth.currentAccount.brn;
    const result = yield call(apis.getContractServiceNumbers, {
      ...reqData,
      brn
    });
    yield put(actions.getContractServiceNumbers.success(result.data));
  } catch (error) {
    yield put(actions.getContractServiceNumbers.failure(error));
  }
}

function* getContractServiceNumbersForTerminateNumber({ reqData }: ContractServiceNumbersForTerminateNumberRequest) {
  try {
    const auth = yield select(getAuth);
    const brn = auth.currentAccount.brn;
    const result = yield call(apis.getContractServiceNumbersForTerminateNumber, {
      ...reqData,
      brn
    });
    yield put(actions.getContractServiceNumbersForTerminateNumber.success(result.data));
  } catch (error) {
    yield put(actions.getContractServiceNumbersForTerminateNumber.failure(error));
  }
}

function* getContractServiceNumbersForChangePlan({ reqData }: ContractServiceNumbersForChangePlanRequest) {
  try {
    const auth = yield select(getAuth);
    const brn = auth.currentAccount.brn;
    const result = yield call(apis.getContractServiceNumbersForChangePlan, {
      ...reqData,
      brn
    });
    yield put(actions.getContractServiceNumbersForChangePlan.success(result.data));
  } catch (error) {
    yield put(actions.getContractServiceNumbersForChangePlan.failure(error));
  }
}

function* getExistingVas({ callback }: any) {
  try {
    const auth = yield select(getAuth);
    const order = yield select(getOrder);
    const { msaHeaderId, brn } = auth.currentAccount;
    const pricePlanId = order.currentOrder.cartDetails?.pricePlan?.pricePlanId;
    const serviceNumberArray = getServiceNumberArray(order.currentOrder.cartDetails?.serviceNumbers);
    let payload = {
      msaHeaderId,
      pricePlanId,
      brn,
      serviceNumber: serviceNumberArray
    }
    const result = yield call(apis.getExistingVas, payload);
    if (result.data?.status === 'FAIL') {
      const error = { response: { data: { code: result.data.error || 'COMMON_SYSTEM_ERROR' } } }
      yield put(actions.getExistingVas.failure(error));
    } else {
      yield put(actions.getExistingVas.success(result.data));
      callback(result.data)
    }
  } catch (error) {
    yield put(actions.getExistingVas.failure(error));
  }
}

function* getFilterByExpiry() {
  try {
    const result = yield call(apis.getFilterByExpiry);
    yield put(actions.getFilterByExpiry.success(result));
  } catch (error) {
    yield put(actions.getFilterByExpiry.failure(error));
  }
}

function* getFilterBySimType() {
  try {
    const result = yield call(apis.getFilterBySimType);
    yield put(actions.getFilterBySIM.success(result));
  } catch (error) {
    yield put(actions.getFilterBySIM.failure(error));
  }
}

function* getActivateSimDetails(reqData) {
  try {
    const result = yield call(apis.getSIMByActivation, reqData.reqData);
    yield put(actions.getActivatedSIM.success(result.data));
    if (result.data.status === 'success') {
      yield call(navigate, 'ORDER_SUCCESS', {});
    }
    if (result.status !== 200) {
      yield call(navigate, 'ORDER_FAILURE', {});
    }
  } catch (error) {
    yield put(actions.getActivatedSIM.failure(error));
  }
}

function* getCeaseAddonsServiceNumbers(reqData) {
  try {
    const payload = reqData.reqData;
    const result = yield call(apis.getCeaseAddonsServiceNumbers, { payload });
    yield put(actions.getCeaseAddonsServiceNumbers.success(result.data));
  } catch (error) {
    yield put(actions.getCeaseAddonsServiceNumbers.failure(error));
  }
}

function* getCeaseAddonsData(reqData) {
  try {
    const payload = reqData.reqData;
    const result = yield call(apis.getCeaseAddonsDetails, payload);
    if (result.data?.status === 'FAIL') {
      yield put(actions.getCeaseAddonsDetails.failure(result.data.status));
    } else {
      yield put(actions.getCeaseAddonsDetails.success(result.data));
    }
  } catch (error) {
    yield put(actions.getCeaseAddonsDetails.failure(error));
  }
}

function* getContractServiceNumbersWithNT({ reqData }: ContractServiceNumbersWithNTRequest) {
  try {
    const auth = yield select(getAuth);
    yield select(getOrder);
    const brn = auth.currentAccount.brn;
    const result = yield call(apis.CustomerServiceNumbersWithNetworkType, {
      ...reqData,
      brn
    });
    yield put(actions.getContractServiceNumbersWithNT.success(result.data));
  } catch (error) {
    yield put(actions.getContractServiceNumbersWithNT.failure(error));
  }
}

function* getSuspendLineServiceNumbers(reqData) {
  try {
    const payload = reqData.reqData;
    const result = yield call(apis.getSupendLineServiceNumbers, payload);
    yield put(actions.getSuspendUnsuspendLineServiceNumbers.success(result.data));
  } catch (error) {
    yield put(actions.getSuspendUnsuspendLineServiceNumbers.failure(error));
  }
}

function* getSuspendLineEligibility({ reqData, callback }: any) {
  try {
    const result = yield call(apis.getSupendLineServiceEligibility, reqData);
    yield put(actions.getSuspendLineEligibilty.success(result.data));
    if (result.data.allSvcNoEligible) {
      callback()
    }
    else {
      const unEligibleNo = result.data.unEligibleSvcNos.join();
      const error = {
        response: {
          data: {
            message: `${unEligibleNo} number(s) not eligible, Please select eligible number to proceed`
          }
        }
      }
      yield put(actions.getSuspendLineEligibilty.failure(error));
    }
  } catch (error) {
    yield put(actions.getSuspendLineEligibilty.failure(error));
  }
}

function* refitServiceNumber(reqData) {
  try {
    const payload = reqData.reqData;
    const result = yield call(apis.refitServiceNumber, payload);
    yield put(actions.refitServiceNumber.success(result));
  } catch (error) {
    yield put(actions.refitServiceNumber.failure(error));
  }
}

export default function* contractSagas() {
  yield takeLatest(CONTRACT_GET_ELIGIBILITY_REQUEST, getRecontractEligibilityValues);
  yield takeLatest(ADDONS_EXISTINGVAS_REQUEST, getAddOnsExistingVasValues);
  yield takeLatest(CONTACT_EXPIRY_REQUEST, getContactExpiryValues);
  yield takeLatest(CONTRACT_GET_SERVICE_NUMBERS_REQUEST, getContractServiceNumbers);
  yield takeLatest(
    CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_REQUEST,
    getContractServiceNumbersForTerminateNumber
  );
  yield takeLatest(CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_REQUEST, getContractServiceNumbersForChangePlan);
  yield takeLatest(CONTRACT_GET_EXISTINGVAS_REQUEST, getExistingVas);
  yield takeLatest(CONTRACT_GET_PRICE_PLANS_REQUEST, getContractPricePlans);
  yield takeLatest(FILTER_BY_EXPIRY_REQUEST, getFilterByExpiry);
  yield takeLatest(FILTER_BY_SIM_REQUEST, getFilterBySimType);
  yield takeLatest(ACTIVATE_SIM_REQUEST, getActivateSimDetails);
  yield takeLatest(CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_REQUEST, getContractServiceNumbersWithNT);
  yield takeLatest(CEASE_ADDONS_GET_SERVICE_NUMBERS_REQUEST, getCeaseAddonsServiceNumbers);
  yield takeLatest(CEASE_ADDONS_DETAILS_REQUEST, getCeaseAddonsData);
  yield takeLatest(SUSPEND_LINE_GET_SERVICE_NUMBERS_REQUEST, getSuspendLineServiceNumbers);
  yield takeLatest(SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_REQUEST, getSuspendLineEligibility);
  yield takeLatest(REFIT_LINE_SERVICE_NUMBERS_REQUEST, refitServiceNumber);
}
